"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function IconListIcon({ children, className, color, identifier, sprite, ...props }) {
    if (!children && (!sprite || !identifier)) {
        throw new Error('If not using `children` to pass in a custom icon, you must provide `sprite` AND `identifier`.');
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('usa-icon-list__icon', color && `text-${color}`, className), "aria-hidden": "true", ...props, children: children || ((0, jsx_runtime_1.jsx)("svg", { className: "usa-icon", role: "img", children: (0, jsx_runtime_1.jsx)("use", { xlinkHref: `${sprite}#${identifier}` }) })) }));
}
exports.default = IconListIcon;
